





























































































































































































import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import { Calendar, getCalendarForYear } from "@/components/calendar/calendar-helper";
import {
  AbsenceTypeEnum,
  AbsenceUserViewModel,
  AbsenceViewModel,
  PublicHolidayViewModel
} from "@/services/api/nswag/stapiclient_generated";
import { DateTime } from "luxon";
import { UserStore } from "@/store/user-module";
import { getAbsenceColor, getPublicHolidayColor } from "@/views/Absence/helper/get-absence-color";

@Component({
  components: {}
})
export default class CalendarView extends Vue {
  @Prop() absenceData!: AbsenceUserViewModel[];
  @Prop() openAbsenceRequests: AbsenceViewModel[];
  @Prop() year!: number;
  loading: boolean = false;

  daywidth: number = 30;
  rowHeight: number = 40;
  headerRowHeight: number = 30;

  get canEditAbsencesForEmployee() {
    return this.userSettings.CanEditAbsencesForEmployees;
  }

  canApprove(absence: AbsenceViewModel) {
    return this.openAbsenceRequests.some(x=>x.id == absence.id);
  }

  get userSettings() {
    return UserStore.userSettings;
  }

  canAddAbsence(appUserId: number) {
    return this.canEditAbsencesForEmployee || appUserId == this.userSettings.appUserId;
  }

  get months(): Calendar {
    return getCalendarForYear(this.year);
  }

  get daysVisible(): boolean {
    return this.daywidth > 20;
  }

  get currentUserId(): number | undefined {
    return UserStore.currentUser.id;
  }

  get currentDateDateTime(): DateTime {
    return DateTime.now().toLocal();
  }

  get publicHolidayColor() {
    return getPublicHolidayColor().BgColorClass;
  }

  async mounted() {
    await this.$nextTick();
    this.scrollToCurrentMonth();
  }

  addAbsence(userId: number, day: DateTime) {
    if (!this.canAddAbsence(userId)) {
      return;
    }
    this.$router.push({
      name: "AbsenceTeamEdit",
      params: { id: "0" },
      query: { userId: userId.toString(), day: day.toFormat("yyyy-MM-dd") }
    });
  }

  editAbsence(id: number) {
    this.$router.push({ name: "AbsenceTeamEdit", params: { id: id.toString() } });
  }

  scrollToCurrentMonth() {
    if (this.year == DateTime.local().year) {
      let calendar = this.$refs.calendar as HTMLElement;
      let refDate = DateTime.local().startOf("month");
      let dayInYear = refDate.diff(DateTime.local().startOf("year"), "days").days;
      calendar.scrollTo({ left: this.daywidth * dayInYear });
    }
  }

  changeDayWidth(val: any) {
    //Sicherstellen, dass der Zoom am aktuellen Tag hängen bleibt, d.h. der aktuelle Tag vorne bleibt der selbe
    let calendar = this.$refs.calendar as HTMLElement;
    let day = Math.floor(calendar.scrollLeft / this.daywidth);

    let newWidth = this.daywidth;
    if (val == 1) {
      newWidth = this.daywidth + 10;
    } else {
      newWidth = this.daywidth - 10;
    }
    calendar.scrollTo({ left: day * newWidth, behavior: "auto" });
    this.daywidth = newWidth;
  }

  getBgClassForAbsence(absence: AbsenceViewModel | null | undefined) {
    if (absence === null || absence === undefined) {
      return "";
    }

    return getAbsenceColor(absence).BgColorClass;
  }

  getBorderClassForAbsence(absence: AbsenceViewModel | null | undefined) {
    if (absence === null || absence === undefined) {
      return "";
    }

    return getAbsenceColor(absence).BorderClass;
  }

  getPublicHolidaysForUser(id: number): PublicHolidayViewModel[] {
    let publicHolidays = this.absenceData!.find((_) => _.appUser?.id == id)!.publicHolidays!;
    return publicHolidays;
  }

  getAbsencesForUser(id: number): AbsenceViewModel[] {
    let absences = this.absenceData!.find((_) => _.appUser?.id == id)!.absences!;

    if (absences.length) {
      absences = absences.filter((_) => !_.isDeclined);
    }

    return absences;
  }

  @Emit("approve")
  approve(absence: AbsenceViewModel) {
    return absence;
  }

  @Emit("reject")
  reject(absence: AbsenceViewModel) {
    return absence;
  }
}
